import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import ValueProps from './components/ValueProps';
import AISection from './components/AISection';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import CaseStudies from './components/CaseStudies';
import Contact from './components/Contact';
import Footer from './components/Footer';
import useScrollReveal from './hooks/useScrollReveal';

export default function App() {
  useScrollReveal();

  return (
    <>
      <Header />
      <main id="top">
        <Hero />
        <About />
        <ValueProps />
        <AISection />
        <Services />
        <Portfolio />
        <CaseStudies />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
